<template>
  <div>
    <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
      <el-row>
        <el-col :span="13">
          <div class="panelContainer">
            <el-form :inline="true" :model="formInline" class="user-search">
              <el-form-item label="所属门店">
                <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small"
                  style="width: 140px;" @change="handleStoreChange">
                  <el-option v-for="item in storeList" :label="item.value" :value="item.keyId"
                    :key="item.keyId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品编号">
                <el-input v-model="formInline.code" placeholder="请输入商品编号" clearable size="small" style="width: 140px;"
                  @change="getListData"></el-input>
              </el-form-item>
              <el-form-item label="商品名称：">
                <el-input style="width: 140px;" v-model="formInline.specification" placeholder="请输入商品名称" clearable
                  size="small"></el-input>
              </el-form-item>
              <el-form-item label="类别">
                <el-select v-model="formInline.typeName" placeholder="请选择类别" clearable filterable size="small"
                  style="width: 140px;" @change="handleTypeNameChange">
                  <el-option v-for="item in typeNameList" :label="item.value" :value="item.keyId"
                    :key="item.keyId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="系列">
                <el-select v-model="formInline.productName" placeholder="请选择系列" clearable filterable size="small"
                  style="width: 140px;" @change="handleProductNameChange">
                  <el-option v-for="item in productNameList" :label="item.value" :value="item.keyId"
                    :key="item.keyId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button v-if="this.$checkBtnPermission('/salesOrder/index', 'viewPage')" size="small"
                  type="primary" class="el-icon-search" @click="handleSearchClick">
                  搜索
                </el-button>
              </el-form-item>
            </el-form>
            <STable :columns="columnsData" :data="listData" :loading="loading" border stripe height="511" highlight
              @row-dblclick="handleRowDoubleClick">
            </STable>
            <!-- 分页组件 -->
            <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
          </div>
        </el-col>
        <el-col :span="11">
          <div class="panelContainer" style="margin-left: 10px;">
            <div class="panelHeader">
            </div>
            <div class="panelContent">
              <el-table :data="listSelectedGoods" border stripe height="620" :highlight-selection-row="true"  @row-dblclick="handleSelectedRowDoubleClick"
                empty-text="请选择商品" :header-cell-style="{ backgroundColor: '#b3e0ff' }" >
                <el-table-column prop="rowNumber" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="typeName" label="类型" width="80" align="center"></el-table-column>
                <el-table-column prop="productName" label="系列" min-width="110" align="center"
                  show-overflow-tooltip></el-table-column>
                <el-table-column prop="specification" label="商品名称" width="150" align="center"
                  show-overflow-tooltip></el-table-column>
                <el-table-column prop="unit" label="单位" width="60" align="center"></el-table-column>
                <el-table-column prop="quantity" label="数量" width="60" align="center"></el-table-column>
                <el-table-column prop="price" label="价格(元)" width="100" align="center"></el-table-column>
                <el-table-column prop="money" label="金额" width="60" align="center"></el-table-column>
              </el-table>
            </div>
            <div class="panelFooter">
              <el-row style="margin-top: 10px;">
                <el-col :span="5">
                  总金额：<span style="font-size: 20px; color: red; font-weight: bold; margin-right: 10px;">{{ totalMoney
                  }}</span>元
                </el-col>
                <el-col :span="5">
                  总数量：<span style="font-size: 20px; color: red; font-weight: bold; margin-right: 10px;">{{ totalQuantity
                  }}</span>个
                </el-col>
                <el-col :span="11">
                  应收金额： <span style="font-size: 20px; color: red; font-weight: bold; margin-right: 10px;">
                    {{ totalMoney }}</span>元
                </el-col>
                <el-col :span="3">
                  <el-button type="danger" class="el-icon-delete" size="mini" style="width: 100%;"
                    @click="clearSelectedGoods">清空</el-button>
                </el-col>
              </el-row>
              <el-row style="margin-top: 10px;">
                <el-col :span="24">
                  <el-button type="warning" class="el-icon-check" style="width: 100%;" @click="showPayDialog">结
                    算</el-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
    </topTab>
    <selectCustomer ref="selectCustomer"></selectCustomer>
    <settlement ref="settlement"></settlement>
  </div>
</template>

<script>
import {
  GetStoreProductPageList,
  GetProductTypeNameList,
  GetProductTypeSubNameList,
} from "@/api/productApi.js";
import {
  GetOrgInfoListByConfig
} from "@/api/organizationalApi.js";
import selectCustomer from "@/views/baseData/customer/selectCustomer.vue";
import settlement from "@/views/product/sales/settlement.vue";
export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "商品销售",
        }
      ],
      loading: false, // 显示加载
      pageShow: true,
      listData: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        storeKeyId: "",
        typeName: "",
        productName: "",
        code: "",
        specification: "",
        isHasQty: true,
      },
      columnsData: [
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          width: "60",
          isKeep: true,
        },
        {
          prop: "storeName",
          label: "门店名称",
          isKeep: true,
          width: "100",
          align: "center",
        },
        {
          prop: "productInfo.typeName",
          label: "类型",
          width: "80",
          align: "center",
        },
        {
          prop: "productInfo.productName",
          label: "系列",
          minWidth: "120",
          align: "center",
        },
        {
          prop: "productInfo.specification",
          label: "商品名称",
          width: "180",
          align: "center",
        },
        {
          prop: "productInfo.unit",
          label: "单位",
          width: "60",
          align: "center",
        },
        {
          prop: "price",
          label: "价格(元)",
          width: "100",
          align: "center",
        },
        {
          prop: "quantity",
          label: "库存数量",
          width: "80",
          align: "center",
        },
      ],
      listSelectedGoods: [],
      totalMoney: 0,
      totalQuantity: 0,
      storeList: [],
      typeNameList: [],
      productNameList: [],
    };
  },
  // 注册组件
  components: {
    selectCustomer,
    settlement,
  },
  created() {
    this.GetOrgInfoListByConfig();
    this.getProductTypeNameList();
    this.getProductTypeSubNameList(this.formInline.typeName);
  },
  computed: {},
  methods: {
    changePages() { },
    // 获取列表
    getListData() {
      if (!this.formInline.storeKeyId) {
        this.$message.error("请选择门店！");
        return;
      }
      this.loading = true;
      GetStoreProductPageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 搜索
    handleSearchClick() {
      this.formInline.pageIndex = 1;
      this.getListData();
    },
    // 获取所属门店
    GetOrgInfoListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrgInfoListByConfig(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.storeList = [];
            if (res.code == 1) {
              res.data.forEach((item) => {
                this.storeList.push({
                  keyId: item.keyId,
                  value: item.name + '【' + item.remark2 + '】',
                });
              });
              this.formInline.storeKeyId = this.storeList[0].keyId;
              this.getListData();
            } else {
              this.$message.error(res.msg);
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 处理左侧表格双击事件
    handleRowDoubleClick(row) {
      // 创建商品数据对象
      const productData = {
        rowNumber: this.listSelectedGoods.length + 1,
        keyId: row.keyId,
        typeName: row.productInfo.typeName,
        productName: row.productInfo.productName,
        specification: row.productInfo.specification,
        unit: row.productInfo.unit,
        quantity: 1,
        price: parseFloat(row.price),
        money: parseFloat(row.price)
      };

      // 查找是否已存在相同商品
      const existingIndex = this.listSelectedGoods.findIndex(
        item => item.keyId === productData.keyId
      );

      if (existingIndex >= 0) {
        // 如果商品已存在，增加数量并重新计算金额
        this.listSelectedGoods[existingIndex].quantity += 1;
        this.listSelectedGoods[existingIndex].money = this.listSelectedGoods[existingIndex].price * this.listSelectedGoods[existingIndex].quantity;
      } else {
        // 如果商品不存在，添加到右侧表格
        this.listSelectedGoods.push(productData);
      }
      var totalMoney = 0;
      var totalQuantity = 0;
      // 更新序号
      this.listSelectedGoods.forEach((item, index) => {
        item.rowNumber = index + 1;
        totalMoney += item.money;
        totalQuantity += item.quantity;
      });
      this.totalMoney = totalMoney;
      this.totalQuantity = totalQuantity;
      this.saleInfo = {
        payType: {
          payTypeId: 1,
          payMoney: totalMoney,
          payComment: "",
        },
        customerKeyId: "",
        dtls: [],
        storeKeyId: "",
        totalMoney: totalMoney,
        totalPayMoney: totalMoney,
        orderSource: 1,
        remark: "",
      };
    },
    // 清空选中商品
    clearSelectedGoods() {
      this.listSelectedGoods = [];
      this.totalMoney = 0;
      this.totalQuantity = 0;
    },
    // 处理门店选择变化
    handleStoreChange(val) {
      this.formInline.storeKeyId = val;
      this.formInline.pageIndex = 1;
      this.clearSelectedGoods();
      this.getListData();
    },
    // 显示选择客户弹窗
    showSelectCustomerDialog() {
      var storeKeyId = this.formInline.storeKeyId;
      if (!storeKeyId) {
        this.$message.error("请选择门店！");
        return;
      }
      this.$refs.selectCustomer.showSelectCustomerDialog(storeKeyId);
    },
    // 选择客户
    chooseCustomer(val) {
      if (!val) {
        this.$message.error("请选择客户！");
        return;
      }
      this.$refs.settlement.submitSelect(val);
    },
    // 显示支付弹窗
    showPayDialog() {
      if (this.listSelectedGoods.length == 0) {
        this.$message.error("请选择商品！");
        return;
      }
      if (!this.formInline.storeKeyId) {
        this.$message.error("请选择门店！");
        return;
      }
      var saleInfo = {
        storeKeyId: this.formInline.storeKeyId,
        totalMoney: this.totalMoney,
        totalQuantity: this.totalQuantity,
        listSelectedGoods: this.listSelectedGoods,
      };
      this.$refs.settlement.showSettlementDialog(saleInfo);
    },
    // 处理类型名称改变
    handleTypeNameChange(val) {
      this.formInline.productName = "";
      this.formInline.pageIndex = 1;
      this.getProductTypeSubNameList(val);
      this.getListData();
    },
    // 处理商品名称改变
    handleProductNameChange(val) {
      this.formInline.productName = val;
      this.formInline.pageIndex = 1;
      this.getListData();
    },
    // 获取商品类型列表
    getProductTypeNameList() {
      GetProductTypeNameList({}).then(res => {
        if (res.code == 1) {
          this.typeNameList = [];
          if (res.code == 1) {
            res.data.forEach((item) => {
              this.typeNameList.push({
                keyId: item.value,
                value: item.value,
              });
            });
          } else {
            this.$message.error(res.msg);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取商品名称列表
    getProductTypeSubNameList(code) {
      var params = {
        code: code,
      };
      GetProductTypeSubNameList(params).then((res) => {
        if (res.code == 1) {
          this.productNameList = [];
          if (res.code == 1) {
            res.data.forEach((item) => {
              this.productNameList.push({
                keyId: item.value,
                value: item.value,
              });
            });
          } else {
            this.$message.error(res.msg);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //选中商品双击后减少数量，如果原本数量为1，则从表格中删除
    handleSelectedRowDoubleClick(row) {
      if (row.quantity <= 1) {
        this.listSelectedGoods = this.listSelectedGoods.filter(item => item.keyId !== row.keyId);
      } else {
        row.quantity -= 1;
        row.money = row.price * row.quantity;
        this.listSelectedGoods = [...this.listSelectedGoods];
      }
      this.totalMoney = this.listSelectedGoods.reduce((acc, item) => acc + item.money, 0);
      this.totalQuantity = this.listSelectedGoods.reduce((acc, item) => acc + item.quantity, 0);
    }
  }
};
</script>

<style scoped lang="scss">
.panelContainer {
  border-radius: 15px;
  height: 720px;
  background-color: #fff;
  margin-top: 10px;
  padding: 20px;
}

.panelFooter {
  margin-top: 20px;
}

.showInfoSpan {
  color: red;
  text-align: center;
  height: 24px !important;
  display: grid;
  align-items: center;
}
</style>